export default __webpack_public_path__ + "29d35cc0123b343a746a3f574b6a8af8.jpg";